export default __webpack_public_path__ + "static/media/shipping.64df99f3.jpg";